import {Component, ElementRef, input, viewChild} from '@angular/core';

@Component({
  selector: 'app-base-input',
  imports: [],
  templateUrl: './base-input.html',
  styleUrl: './base-input.css',
})
export class BaseInput {
  id = input<string>(Math.random().toString(36).substring(2));
  name = input<string>('');
  label = input<string>('');
  placeholder = input<string>(' ');
  disabled = input<boolean>(false);
  required = input<boolean>(false);
  autofocus = input<boolean>(false);
  help = input<string>();

  inputElement = viewChild<ElementRef<HTMLElement>>('inputElement');

  focus(timeout: number = 50) {
    setTimeout(() => {
      this.inputElement()?.nativeElement.focus();
    }, timeout);
  }
}
